import { createBrowserHistory } from 'history'

export default createBrowserHistory({
  keyLength: 10
})
